const colors = [
  '#5462FF',
  '#E9A3F9',
  '#FFB023',
  '#BF83FC',
  '#A689FA',
  '#8C96FC',
  '#61A6FA',
  '#3ABFF8',
  '#20D3EE',
  '#2BD4BD',
  '#36D399',
  '#4ADE80',
  '#96DB29',
  '#FACC14',
  '#FB923C',
  '#FF6565',
  '#FB6F84',
  '#F471B5',
];

export { colors };

export const CHART_TYPES = {
  METRIC: 'Metric',
  DONUT: 'Donut',
  PIE: 'Pie',
  LINE: 'Line',
  BAR: 'Bar',
  STACK_BAR: 'Stack bar',
  HORIZONTAL_BAR: 'Horizontal bar',
  HORIZONTAL_STACK_BAR: 'Horizontal stack bar',
  BUBBLE: 'Bubble',
  PYRAMID: 'Pyramid',
  DATA_GRID: 'DataGrid',
  BOXPLOT: 'Boxplot',
  HORIZONTAL_BOXPLOT: 'Horizontal boxplot',
  FUNNEL: 'Funnel',
  TABLE: 'Table',
};

export const APEX_CHART_TYPES = {
  BAR: 'bar',
  LINE: 'line',
  PIE: 'pie',
  DONUT: 'donut',
  BOXPLOT: 'boxPlot',
};

export const TIME_PERIODS = {
  CURRENT: 'Current',
  PREV: 'Prev',
};
export const TIME_INTERVALS = [TIME_PERIODS.PREV, TIME_PERIODS.CURRENT];

export const BASE_EXCLUDES = [
  'time_grouping_interval',
  'time_grouping_date',
  'time_group_date',
  'tenure_sort',
  'TenureMacroSortOrder',
  'groupByForSort',
  'employees_attributes_groupBy.attribute_value',
  'nb_employees_arrived',
  'nb_employees_left',
  'begin_headcount',
  'end_headcount',
  'arrivals',
  'nb_employees_begin_period',
  'ignore',
  'previousValue',
  'NoGrouping',
  'currentValue',
];

export const getHardcodedExcludes = (multiGrouping = []) => {
  if (!Array.isArray(multiGrouping) || multiGrouping.length === 0) {
    return BASE_EXCLUDES;
  }

  const dynamicExcludes = multiGrouping.map((group) => {
    const trimmedString = group?.trim()?.split(' ')?.join('_');
    return `employees_attributes_groupBy_${trimmedString}.attribute_value`;
  });

  return [...BASE_EXCLUDES, ...dynamicExcludes];
};

export const COMPARISON_MODES = {
  VS_LAST_YEAR: 'Vs Last Year',
};

export const GAP_TYPES = {
  ABSOLUTE_VALUE: 'AbsoluteValue',
  RELATIVE_VALUE: 'RelativeValue',
};

export const UI_CONSTANTS = {
  DEFAULT_WIDTH: '100%',
  DEFAULT_HEIGHT: 600,
  DEFAULT_FIELD_WIDTH: 120,
  SECONDARY_FIELD_WIDTH: 180,
  METRIC_COLUMN_WIDTH: 120,
  EVOLUTION_COLUMN_WIDTH: 130,
  PINNED_COLUMNS_COUNT: 2,
  MAX_ROWS_WITHOUT_FOOTER: 25,
};

export const DISPLAY_TEXT = {
  NO_DATA: 'No data available',
  SUBTOTAL: 'SubTotal',
  TOTAL: 'Total',
  ABS_SUFFIX: ' (Abs)',
  PERCENT_SUFFIX: ' (%)',
  PERCENT_SYMBOL: '%',
  DASH: '-',
  PLUS: '+',
  EMPTY: '',
  VS_SEPARATOR: ' vs ',
  CURRENCY_SYMBOL: '€',
};

export const COLORS = {
  POSITIVE: '#4caf50',
  NEGATIVE: '#f44336',
  WHITE: 'white',
  LIGHT_GRAY: '#F7F9FC',
  BORDER_GRAY: '#e0e0e0',
  HOVER_GRAY: '#f5f5f5',
  SUBTOTAL_BG: '#fafafa',
  TOTAL_BG: '#f0f0f0',
  LIGHT_BLUE: '#E8F0FE',
  BLUE: '#1976d2',
  CELL_BORDER: '#f0f0f0',
};

export const REGEX_PATTERNS = {
  MONTH_YEAR: /^(\w{3})\s+(\d{4})$/,
  YEAR_MONTH: /^(\d{4})-(\d{2})$/,
  FULL_DATE: /^(\d{4})-(\d{2})-(\d{2})$/,
  YEAR_ONLY: /^(\d{4})$/,
  QUARTER: /^Q(\d)\s+(\d{4})$/,
  YEAR_EXTRACT: /(\d{4})/,
  ALPHANUMERIC: /[^a-zA-Z0-9_]/g,
};
